import classNames from 'classnames';
import React from 'react';
import { Loader } from '@myinterview/component-library';
import { isMobile } from '../utils/device.utils';

interface IProps {
  backgroundColor?: string;
  backgroundImage?: string;
  showWatermark: boolean;
  isLoading: boolean
}
export const RightSide = ({
  backgroundColor, backgroundImage, showWatermark, isLoading,
}: IProps) => {
  const shouldShowMotto = document.documentElement.getAttribute('data-custom') === 'momentum';
  const classes = classNames({
    'right-side': true,
    'right-side--loading': isLoading,
    'right-side--water-mark': showWatermark,
    'right-side--circle': !backgroundImage,
  });
  let backgroundStyle = {};
  if (backgroundImage) backgroundStyle = { backgroundImage: `${isMobile ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),' : ''}url(${backgroundImage})` };
  else if (backgroundColor) backgroundStyle = { background: backgroundColor };
  return (
    <div
      className={classes}
      style={backgroundStyle}
    >
      {isLoading && <Loader />}
      {shouldShowMotto && (
      <div className="momentum-motto intel-motto">
        CLIENT ENGAGEMENT SOLUTIONS
        <br />
        <span>Come shine bright with us</span>
      </div>
      )}
    </div>
  );
};
